export default __webpack_public_path__ + "static/media/678.04a61fac.png";